export default __webpack_public_path__ + "static/media/Lara 9781408303504.84695226.jpg";